export default __webpack_public_path__ + "static/media/help.d35a1ac7.svg";